export function set(key, value, expirationInSec) {
    try {
        const data = { value };
        if (expirationInSec) {
            data.expiration = Date.now() + (expirationInSec * 1000)
        }
        window.localStorage.setItem(key, JSON.stringify(data));
    } catch (err) {
        console.error(err);
    }
}

export function get(key) {
    try {
        const value = window.localStorage.getItem(key);
        if (value === null) {
            return undefined;
        }
        const data = JSON.parse(value);
        if (data.expiration && data.expiration < Date.now()) {
            remove(key);
            return undefined;
        }
        return data.value;
    } catch (err) {
        return undefined;
    }
}

export function remove(key) {
    try {
        window.localStorage.removeItem(key);
    } catch (err) {
        console.error(err);
    }
}


export function setSessionItem(key, object) {
    try {
        window.sessionStorage.setItem(key, JSON.stringify(object));
    } catch(err) {
        return undefined;
    }
}

export function getSessionItem(key) {
    try {
        const value = window.sessionStorage.getItem(key);
        return value && JSON.parse(value);
    } catch (err) {
        return undefined;
    }
}



// WEBPACK FOOTER //
// ./app/lib/util/localStorage.js